import React from 'react';
import InsuranceScreen from './screens/Insurance/InsuranceScreen';

function Insurance() {
  return (
    <>
      <InsuranceScreen />
    </>
  );
}

export default Insurance;
